import { useState } from 'react';
import cn from 'classnames';

const copy = (value: string) => {
  const el = document.createElement(`textarea`);
  el.value = value;
  el.setAttribute(`readonly`, ``);
  el.style.position = `absolute`;
  el.style.left = `-9999px`;
  document.body.appendChild(el);
  el.select();
  document.execCommand(`copy`);
  document.body.removeChild(el);
};

type CopyToClipboardProps = {
  value: string;
  className?: string;
};

export default function CopyToClipboard({
  value,
  className,
}: CopyToClipboardProps) {
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    setCopied(true);
    copy(value);

    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        `appearance-none focus:outline-none inline-flex items-center hover:cursor-pointer`,
        className,
      )}
      aria-label={copied ? `Copied!` : `Copy to Clipboard`}
      data-balloon-pos="down"
    >
      <svg
        className="fill-current w-5 h-5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path d="M6 6V2c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h4zm2 0h4a2 2 0 0 1 2 2v4h4V2H8v4zM2 8v10h10V8H2z" />
      </svg>
    </button>
  );
}
